import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="mt-32 bg-sage-deep text-cream/90">
    <div className="mx-auto max-w-6xl px-6 py-20">
      <div className="grid gap-14 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-serif text-4xl italic">Artemisia Benessere</p>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/60">
            Armonia e presenza attraverso pratiche millenarie e cura consapevole.
            Yoga, massaggi, meditazione e cucina consapevole con Agnese Caon.
          </p>
          <div className="mt-7 flex flex-col gap-3 text-sm">
            <a href="tel:+393488598613" data-testid="footer-phone" className="flex items-center gap-3 text-cream/80 transition-colors hover:text-cream">
              <Phone className="h-4 w-4" /> 348 859 8613
            </a>
            <a href="mailto:artemisia.agnese@gmail.com" data-testid="footer-email" className="flex items-center gap-3 text-cream/80 transition-colors hover:text-cream">
              <Mail className="h-4 w-4" /> artemisia.agnese@gmail.com
            </a>
            <a href="https://www.google.com/maps/search/?api=1&query=Via+Stortina+1,+31023+Resana+TV" target="_blank" rel="noreferrer" data-testid="footer-address" className="flex items-center gap-3 text-cream/80 transition-colors hover:text-cream">
              <MapPin className="h-4 w-4" /> Via Stortina 1, 31023 Resana (TV)
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-cream/80 transition-colors hover:text-cream">
              <Instagram className="h-4 w-4" /> @artemisia_benessere
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cream/50">Orari</p>
          <ul className="mt-5 space-y-2.5 text-sm text-cream/70">
            <li>Lun – Ven: 13:45 – 19:00</li>
            <li>Sabato: 10:30 – 16:00</li>
            <li>Domenica: Chiuso</li>
            <li className="pt-2 text-cream/50">Solo su appuntamento</li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cream/50">Esplora</p>
          <ul className="mt-5 space-y-2.5 text-sm">
            {[
              ["/servizi", "Servizi & Trattamenti"],
              ["/chi-sono", "Chi Sono"],
              ["/eventi", "Eventi & Sessioni"],
              ["/contatti", "Prenota"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="text-cream/70 transition-colors hover:text-cream">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-8 text-xs text-cream/40 sm:flex-row">
        <p>© 2026 Artemisia Benessere — Armonia e Presenza</p>
        <p>Agnese Caon · P.IVA 05151080263 · Via Stortina 1, Resana (TV)</p>
      </div>
    </div>
  </footer>
);

export default Footer;
